import { render, staticRenderFns } from "./BindCount.vue?vue&type=template&id=f344418e&scoped=true"
import script from "./BindCount.vue?vue&type=script&lang=js"
export * from "./BindCount.vue?vue&type=script&lang=js"
import style0 from "./BindCount.vue?vue&type=style&index=0&id=f344418e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f344418e",
  null
  
)

export default component.exports